"use client";

export interface RuleItem {
  label: string;
  tone: "ok" | "warn";
}

export interface RulesSectionProps {
  ruleItems: RuleItem[];
  rulesAndRegulations?: string | null;
}

function CheckIcon({ className = "h-4 w-4" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M20 6L9 17l-5-5" />
    </svg>
  );
}

export function RulesSection({ ruleItems, rulesAndRegulations }: RulesSectionProps) {
  if (ruleItems.length === 0 && !rulesAndRegulations) return null;

  return (
    <div className="bg-[#0c0c18] border border-white/[0.08] rounded-[20px] p-7 transition-colors hover:border-white/[0.12]">
      <div className="flex items-center justify-between mb-5">
        <span className="text-[11px] uppercase tracking-[0.1em] font-semibold text-white/50">Rules</span>
      </div>
      {ruleItems.length > 0 && (
        <div className="space-y-2.5">
          {ruleItems.map((rule, index) => (
            <div key={`${rule.label}-${index}`} className="flex items-start gap-3 p-3 rounded-lg bg-white/[0.04] text-[13px] text-white/60 leading-relaxed">
              <div className="w-[34px] h-[34px] flex-shrink-0 flex items-center justify-center rounded-lg bg-[#0c0c18] text-white/50">
                {rule.tone === "warn" ? (
                  <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M12 9v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                ) : (
                  <CheckIcon className="h-4 w-4" />
                )}
              </div>
              <span className={rule.tone === "warn" ? "text-amber-400/70" : ""}>{rule.label}</span>
            </div>
          ))}
        </div>
      )}
      {rulesAndRegulations && (
        <div className={ruleItems.length > 0 ? "mt-5 pt-5 border-t border-white/[0.06]" : ""}>
          <span className="text-[11px] uppercase tracking-[0.1em] font-semibold text-white/50 block mb-3">Rules & Regulations</span>
          <p className="text-[13px] text-white/60 leading-relaxed whitespace-pre-wrap">{rulesAndRegulations}</p>
        </div>
      )}
    </div>
  );
}
